import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FooterSection = ({ currentLanguage }) => {
  const content = {
    EN: {
      company: "PSPXpress",
      tagline: "Building credit futures, one card at a time",
      pages: "Pages",
      legal: "Legal",
      contact: "Contact",
      rights: "© 2024 PSPXpress. All rights reserved.",
      disclaimer: "Important disclaimers apply. Credit building results may vary. Equifax® is a registered trademark.",
      nav: {
        home: "Home",
        howItWorks: "How It Works", 
        cardBenefits: "Card & Benefits",
        faq: "FAQ",
        apply: "Apply"
      },
      legalLinks: {
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        disclaimers: "Disclaimers"
      }
    },
    FR: {
      company: "PSPXpress",
      tagline: "Construire l'avenir du crédit, une carte à la fois",
      pages: "Pages",
      legal: "Juridique",
      contact: "Contact",
      rights: "© 2024 PSPXpress. Tous droits réservés.",
      disclaimer: "Des avertissements importants s'appliquent. Les résultats de création de crédit peuvent varier. Equifax® est une marque déposée.",
      nav: {
        home: "Accueil",
        howItWorks: "Comment ça marche",
        cardBenefits: "Carte et avantages",
        faq: "FAQ",
        apply: "Appliquer"
      },
      legalLinks: {
        terms: "Conditions d\'utilisation",
        privacy: "Politique de confidentialité",
        disclaimers: "Avis de non-responsabilité"
      }
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">PSP</span>
              </div>
              <span className="text-xl font-bold">{text?.company}</span>
            </div>
            <p className="text-gray-400 mb-6">
              {text?.tagline}
            </p>
            <div className="flex space-x-4">
              <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors">
                <Icon name="Twitter" size={20} className="text-gray-400" />
              </div>
              <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors">
                <Icon name="Facebook" size={20} className="text-gray-400" />
              </div>
              <div className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors">
                <Icon name="Linkedin" size={20} className="text-gray-400" />
              </div>
            </div>
          </div>

          {/* Pages */}
          <div>
            <h3 className="font-semibold mb-4">{text?.pages}</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">{text?.nav?.home}</Link></li>
              <li><Link to="/how-it-works" className="text-gray-400 hover:text-white transition-colors">{text?.nav?.howItWorks}</Link></li>
              <li><Link to="/card-benefits" className="text-gray-400 hover:text-white transition-colors">{text?.nav?.cardBenefits}</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-white transition-colors">{text?.nav?.faq}</Link></li>
              <li><Link to="/apply" className="text-gray-400 hover:text-white transition-colors">{text?.nav?.apply}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">{text?.legal}</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">{text?.legalLinks?.terms}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">{text?.legalLinks?.privacy}</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">{text?.legalLinks?.disclaimers}</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">{text?.contact}</h3>
            <div className="space-y-2 text-gray-400">
              <div className="flex items-center space-x-2">
                <Icon name="Phone" size={16} />
                <span>1-800-PSP-CARD</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Mail" size={16} />
                <span>support@pspxpress.ca</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="MapPin" size={16} />
                <span>Toronto, Canada</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              {text?.rights}
            </div>
            <div className="text-gray-500 text-xs text-center md:text-right max-w-md">
              {text?.disclaimer}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;